import { render, staticRenderFns } from "./MobileScreenTransaction.vue?vue&type=template&id=4ce7873a&"
import script from "./MobileScreenTransaction.vue?vue&type=script&lang=js&"
export * from "./MobileScreenTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports